module.exports = __webpack_public_path__ + "static/media/filepdf.2beb2685.svg";